<template>
  <v-dialog v-model="dialog.help" lazy max-width="700">
    <v-card>
      <v-card-title>
        <h3>使い方</h3>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-title>
        <v-layout>
          <v-flex xs1 xl1>
            <v-icon color="secondary">check</v-icon>
          </v-flex>
          <v-flex xs11 class="mt-1">
          <span>キャラクターそれぞれの自動戦闘時間や毎日のタスクを管理することができます。</span>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3">
          <v-flex xs1>
            <v-icon color="secondary">check</v-icon>
          </v-flex>
          <v-flex xs11 class="mt-1">
          <span>チェックリストは毎日0時にリセットされます。</span>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3">
          <v-flex xs1>
            <v-icon color="secondary">check</v-icon>
          </v-flex>
          <v-flex xs11 class="mt-1">
          <span>キャラクターの表示モードを2種類用意しています。（詳細モード / 一覧モード）</span>
          </v-flex>
        </v-layout>

        <v-layout class="mt-3">
          <v-flex xs1>
            <v-icon color="secondary">check</v-icon>
          </v-flex>
          <v-flex xs11 class="mt-1">
          <span>キャラクターが多くなっても、いちいちゲーム内でキャラ変更して確認する手間が省けます！</span>
          </v-flex>
        </v-layout>
      </v-card-title>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="dialog.help=false" color="secondary">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['dialog'],
  }
</script>